<div class="faq-wrapper">
  <ion-text color="light">
    <h3>FAQ</h3>
  </ion-text>
  <ion-accordion-group>
      <ion-accordion [value]="faq.label" *ngFor="let faq of faqs">
          <ion-item slot="header" color="primary">
            <ion-label>{{ faq.label }}</ion-label>
          </ion-item>

          <div class="ion-padding" slot="content">
            <ion-accordion-group>
              <ion-accordion [value]="item.label" *ngFor="let item of faq.items">
                  <ion-item slot="header" color="light">
                  <ion-label>{{ item.label }}</ion-label>
                  </ion-item>
                  <div class="ion-padding" slot="content">{{ item.content }}</div>
              </ion-accordion>
            </ion-accordion-group>
          </div>
      </ion-accordion>
  </ion-accordion-group>
</div>